// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import ScrollShadow from '../../../../components/ScrollShadow';
import KLPoleChipContainer from '../../containers/KLPoleChipContainer';

const Wrapper = styled(ScrollShadow)`
  display: flex;
  flex-direction: column;
  align-items: center;

  & > * {
    padding: 0.8em;
  }
`;

type KLPoleChipListProps = {
  maxAttempts: number;
};

const KLPoleChipList = ({ maxAttempts }: KLPoleChipListProps) => {
  return (
    <Wrapper>
      {[...new Array(maxAttempts).keys()].map((index) => (
        <KLPoleChipContainer key={`kl-pole-chip-${index}`} index={index} />
      ))}
    </Wrapper>
  );
};

export default KLPoleChipList;
